// import * as csstree from 'css-tree'
import postcss from 'postcss'

export const json = (value) => {
    if (typeof value === 'string' && value.length) {
        try {
            JSON.parse(value)
        } catch (error) {
            return { success: false, error: error }
        }
    }
    return { success: true }
}

const normalizeCssError = (error, type = 'css') => {
    if (!error) {
        return { message: 'Invalid CSS syntax.' }
    }

    const line = Number.isInteger(error.line) ? ` (line ${error.line}` : ''
    const column = Number.isInteger(error.column) ? `, column ${error.column}` : ''
    const position = line ? `${line}${column})` : ''
    const css = error.message || 'Invalid CSS syntax.'
    const scss =  error.reason || error.message || 'Invalid CSS syntax.'
    const reason = type === 'scss' ? scss : css

    let context = ''
    try {
        context = (error.source.split('\n')[error.line - 1] || '').trim()
        
        if (context)
            context = ": " + (context.length > 50 ? context.slice(0, 50) + '...' : context)
    }
    catch (e) { }

    return {
        message: `${reason}${position}${context}`,
        line: error.line,
        column: error.column,
        source: type === 'scss' ? error.source : undefined,
        offset: type === 'css' ? error.offset : undefined,
        raw: error
    }
}

// export const css = (value) => {
//     if (typeof value !== 'string' || !value.trim().length) {
//         return { success: true }
//     }

//    let error = []
//     csstree.parse(value, {
//         onParseError: (err) => error.push(normalizeCssError(err))
//     })

//     if (error.length) {
//         return { success: false, error }
//     }

//     return { success: true }
// }
export const css = (value) => {
    return scss(value)
}

export const scss = (value) => {
    if (typeof value !== 'string' || !value.trim().length) {
        return { success: true }
    }
    try {
        postcss.parse(value)
    } catch (error) {
        console.error('CSS validation error:', error)
        return { success: false, error: normalizeCssError(error, 'scss') }
    }
    return { success: true }
}

export default {
    scss,
    css,
    json
}